import { useState } from "react";

const Tabs = () => {
  let listed = ["Africa", "Europe", "North America", "Asia", "South America"];
  const [currTab, setCurrTab] = useState(1);
  return (
    <div className="flex gap-4 py-6">
      {listed.map((item, idx: number) => {
        return (
          <div
            onClick={() => {
              setCurrTab(idx);
            }}
            className={`rounded-lg px-3 py-2 text-sm cursor-pointer ${
              currTab == idx
                ? "bg-[#000046] text-white font-bold"
                : "bg-white text-[#000046]"
            }`}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};
export default Tabs;
